import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  Divider,
  Center,
  Button,
  Text,
  Input,
  InputGroup,
  InputLeftAddon,
  Heading,
  VStack,
  RadioGroup,
  Radio,
  Select,
  HStack,
  Grid,
  GridItem,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { ColorModeSwitcher } from "../../ColorModeSwitcher";
import { Nav } from "../../containers/Nav";
import { getBrand, updateBrand } from "../../actions/brands";
import { validateUserAuth } from "../../helpers";

function Account() {
  const toast = useToast();
  const navigate = useNavigate;

  const [organization, setOrganization] = useState({});
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [occupation, setOccupation] = useState("");
  const [address, setAddress] = useState("");

  const [existingPassword, setExistingPassword] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [passwordError, setPasswordError] = useState("")

  const lightGray = useColorModeValue("gray.600", "gray.100");

  const submitProfile = async () => {
    let updateBody = {};
    if (name !== organization.name) {
      updateBody.name = name;
    }
    if (email !== organization.email) {
      updateBody.email = email;
    }
    if (occupation !== organization.occupation) {
      updateBody.occupation = occupation;
    }
    if (address !== organization.address) {
      updateBody.address = address;
    }

    if (existingPassword && password1) {
      updateBody.oldPassword = existingPassword;
      updateBody.password = password1;
    }

    const response = await updateBrand(updateBody);
    if (response.ok) {
      setOrganization({ ...organization, ...updateBody });
      toast({
        title: `Profile has been saved!`,
        status: "success",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  const changePassword = async () => {
    //const response = await 
    try {
      const response = await updateBrand({
        oldPassword: existingPassword, 
        newPassword: password1
      })
      console.log(response)
      if(response.error){
        toast({
          title: response.error,
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      } else {
        toast({
          title: `Password has been saved!`,
          status: "success",
          duration: 4000,
          isClosable: true,
        });
      }
    } catch(err){
      toast({
        title: err,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
    /*
    if (response.ok) {
    } else if(response.error) {
    }
    */
    
  }

  useEffect(() => {
    const rawJwt = localStorage.getItem("jwtToken").split("Bearer ")[1];
    const parsedJWT = JSON.parse(atob(rawJwt.split(".")[1]));

    const userInfo = validateUserAuth();
    const brand = userInfo.organization;
    if (!brand) {
      navigate("/home");
    }

    if (userInfo.organization) {
      getBrand(userInfo.organization).then((org) => {
        setOrganization(org);

        setEmail(org.email);
        setName(org.name);
        setOccupation(org.occupation);
        setAddress(org.address);
      });
    }
  }, []);

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      h="200px"
      color="blackAlpha.700"
    >
      <Nav />

      <GridItem pl="2" area={"main"}>
        <Center>
          <VStack>
            <Box mt="8">
              <Heading
                color={useColorModeValue("gray.1000", "gray.100")}
                fontSize="2xl"
              >
                Account Settings
              </Heading>
            </Box>

            <Card
              mx="5"
              my="5"
              p="45px"
              maxW="2xl"
              minW="2xl"
              bg={useColorModeValue("gray.100", "gray.900")}
              align="top"
            >
              <Box mb="4">
                <InputGroup>
                  <InputLeftAddon background="gray.300" children="Email" />
                  <Input
                    onChange={(e) => setEmail(e.target.value)}
                    type="text"
                    value={email}
                    placeholder="email address"
                  />
                </InputGroup>
              </Box>
              <Box mb="4">
                <InputGroup>
                  <InputLeftAddon background="gray.300" children="Name" />
                  <Input
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    type="text"
                    value={name}
                    placeholder="first and last name"
                  />
                </InputGroup>
              </Box>
              <Box mb="4">
                <InputGroup>
                  <InputLeftAddon background="gray.300" children="Occupation" />
                  <Input
                    onChange={(e) => setOccupation(e.target.value)}
                    type="text"
                    value={occupation}
                    placeholder="occupation"
                  />
                </InputGroup>
              </Box>
              <Box mb="4">
                <InputGroup>
                  <InputLeftAddon background="gray.300" children="Address" />
                  <Input
                    type="text"
                    onChange={(e) => setAddress(e.target.value)}
                    value={address}
                    placeholder="address"
                  />
                </InputGroup>
              </Box>

              <Center mb="6">
                <Button
                  isDisabled={
                    (name === organization.name &&
                      email === organization.email &&
                      occupation === organization.occupation &&
                      address === organization.address) ||
                    name === "" ||
                    email === "" ||
                    occupation === "" ||
                    address === "" ||
                    !email.includes("@")
                  }
                  onClick={submitProfile}
                  colorScheme="green"
                >
                  Save Changes
                </Button>
              </Center>

              <Divider mb="4" />

              <Center mb="4">
                <Heading fontSize="lg">Change password</Heading>
              </Center>

              <Box mb="6">
                <InputGroup>
                  <InputLeftAddon
                    background="gray.300"
                    children="Existing password"
                  />
                  <Input
                    onChange={(e) => setExistingPassword(e.target.value)}
                    type="password"
                    value={existingPassword}
                  />
                </InputGroup>
              </Box>
              <Box mb="4">
                <InputGroup>
                  <InputLeftAddon
                    background="gray.300"
                    children="New password"
                  />
                  <Input 
                    onChange={(e) => {
                      setPassword1(e.target.value)
                      if(passwordError) setPasswordError("")
                    }}
                    type="password" 
                    value={password1}
                  />
                </InputGroup>
              </Box>
              <Box mb="4">
                <InputGroup>
                  <InputLeftAddon
                    background="gray.300"
                    children="New password again"
                  />
                  <Input
                    onChange={(e) => {
                      setPassword2(e.target.value)
                      if(passwordError) setPasswordError("")
                    }}
                    type="password" 
                    value={password2}
                  />
                </InputGroup>
              </Box>
              <Center mb="6">
                <Button
                  onClick={(evt)=>{
                    if(password1 !== password2){
                      setPasswordError("New passwords do not match")
                    }
                    if(!existingPassword){
                      setPasswordError("Existing password is missing")
                    }
                    changePassword()
                  }}
                  isDisabled={
                    !existingPassword || !password1 || !password2 // || password1 !== password2
                  }
                  colorScheme="green"
                >
                  Change Password
                </Button>
              </Center>
              {passwordError.length > 0 && 
                <Center>
                  <Text color="red">{passwordError}</Text>
                </Center>
              }
            </Card>
            <Box
              minWidth="2xl"
              maxWidth="2xl"
              mx="5"
              mb="2"
              justifyContent="left"
            >
              <Link to="/campaigns">
                <Text as="u" color="teal">
                  &lt;&lt; Go back home
                </Text>
              </Link>
            </Box>
          </VStack>
        </Center>
      </GridItem>
    </Grid>
  );
}

export default Account;
